import { trackAllPlatforms } from './platforms';

class Tracking {
  /**
   * Process the value attribute to remove newlines, if the value attribute exists.
   *
   * @param {any} attributes
   */
  processAttributes(attributes) {
    if (!attributes) return {};

    let { value, ...additionalAttributes } = attributes;
    if (value) {
      value = value.replace(/\r?\n|\r/g, "");
    }
    return { value, ...additionalAttributes };
  }

  /**
   * Send a tracking event to any tracking platforms defined in the `trackAllPlatforms` array.
   *
   * @param {string} category The event category, e.g. "cart-cloud" or "bxp.formCloudSignup".
   * @param {string} action The action name, e.g. "page-unload" or "time-to-form-ready".
   * @param {string} label An event label, e.g. "form-event" or "signup-social-login". Not used by all platforms.
   * @param {any} attributes Additional attributes passed to the tracking platform.
   * @param {string} optimizelyValue A plain string to pass to Optimizely as the event name. Deprecated.
   * @param {boolean} isNonInteraction Whether or not the event is a non-interaction event (Google Analytics). See also, https://support.google.com/analytics/answer/1033068#NonInteractionEvents
   */
  trackAll(category, action, label, attributes = {}, optimizelyValue, isNonInteraction) {
    const attrs = this.processAttributes(attributes);

    trackAllPlatforms.forEach(platform => {
      platform.track({
        category,
        action,
        label,
        attributes: attrs,
        optimizelyValue,
        isNonInteraction,
      });
    })
  }
}

export { Tracking };

export default new Tracking();
